import { useState } from 'react'
import styles from '../../../pages/Badging/MainBadgeTemplateStyling/MainBadgeTemplateStyling.module.css'

// ------ Font Awesome assets ------ //
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareCaretUp, faSquareCaretDown } from '@fortawesome/free-solid-svg-icons'

// ------ Image Elements ------ //
const up = <FontAwesomeIcon icon={faSquareCaretUp} style={{ color: 'blue', width: '20px', height: '20px' }} />
const down = <FontAwesomeIcon icon={faSquareCaretDown} style={{ color: 'blue', width: '20px', height: '20px' }} />

const BadgeProperty = ({
    badgeProperty,
    index,
    CSSValues,
    onCSSChange
}) => {

    const [isHidden, setIsHidden] = useState(true)

    const fontFamilies = [
        "Amatic SC",
        "Archivo",
        "Arial",
        "Avenir",
        "Baloo",
        "Baskerville",
        "Bebas Neue",
        "Cabin",
        "Calibri",
        "Century Gothic",
        "Comfortaa",
        "Copperplate Gothic",
        "Courier New",
        "Dancing Script",
        "Dosis",
        "Droid Sans",
        "Franklin Gothic",
        "Futura",
        "Garamond",
        "Georgia",
        "Gotham",
        "Helvetica",
        "Hind",
        "Josefin Sans",
        "Lato",
        "Lobster",
        "Merriweather",
        "Montserrat",
        "Museo Sans",
        "Myriad Pro",
        "Noticia Text",
        "Nunito Sans",
        "Open Sans",
        "Oswald",
        "Pacifico",
        "Palatino",
        "Playfair Display",
        "Poppins",
        "Proxima Nova",
        "Quicksand",
        "Raleway",
        "Roboto",
        "Rockwell",
        "Source Sans Pro",
        "Spectral",
        "Tahoma",
        "Times New Roman",
        "Trade Gothic",
        "Ubuntu",
        "Verdana"
    ]

    const CSSBadgeProperty = CSSValues[badgeProperty]

    const CSSfontSize = CSSBadgeProperty.fontSize
    const CSSfontFamily = CSSBadgeProperty.fontFamily
    const CSSmargin = CSSBadgeProperty.margin
    const CSSpadding = CSSBadgeProperty.padding
    const CSSfontWeight = CSSBadgeProperty.fontWeight
    const CSStextTransform = CSSBadgeProperty.textTransform
    const CSSdisplay = CSSBadgeProperty.display
    const CSSlineHeight = CSSBadgeProperty.lineHeight
    const CSSborder = CSSBadgeProperty.border
    const CSSwidth = CSSBadgeProperty.width
    const CSSheight = CSSBadgeProperty.height
    const CSSposition = CSSBadgeProperty.position
    const CSStop = CSSBadgeProperty.top
    const CSSleft = CSSBadgeProperty.left
    const CSSright = CSSBadgeProperty.right
    const CSSbottom = CSSBadgeProperty.bottom

    const handleStyleChange = (property, value) => {
        onCSSChange(property, value)
    }

    return (
        <>
            <div id={styles.badgeProperty} key={index} onClick={() => setIsHidden(!isHidden)}>
                {badgeProperty} {isHidden ? down : up}
            </div>

        {
                !isHidden ? 
                    <form
                        autoComplete="off"
                        id={styles.CSSForm}
                    >
                        <label htmlFor="fontSize" className={styles.label} title="Absolute lengths(NNpx) or Relative lengths(NNem, NNrem, NN%, and Nvw/vh)">Font Size</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSfontSize}
                            name="fontSize"
                            onChange={(e) => handleStyleChange('fontSize', e.target.value)}
                            className={styles.formInput}
                        />

                        <label htmlFor="fontFamily" className={styles.label}>Font Family</label>
                        <select
                            name="fontFamily"
                            value={CSSfontFamily}
                            onChange={(e) => handleStyleChange('fontFamily', e.target.value)}
                            className={styles.formInput}

                        >
                            <option disabled={false} value="" selected="selected">
                                -- Select an option --
                            </option>
                            {
                                fontFamilies.map((font, idx) => (
                                    <option key={idx}>{font}</option>
                                ))
                            }
                        </select>

                        <label htmlFor="margin" className={styles.label} title="NNpx NNpx NNpx NNpx (top, right, bottom, left)">Margin</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSmargin}
                            name="margin"
                            onChange={(e) => handleStyleChange('margin', e.target.value)}
                            className={styles.formInput}
                        />

                        <label htmlFor="padding" className={styles.label} title="NNpx NNpx NNpx NNpx (top, right, bottom, left)">Padding</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSpadding}
                            name="padding"
                            onChange={(e) => handleStyleChange('padding', e.target.value)}
                            className={styles.formInput}
                        />

                        <label htmlFor="fontWeight" className={styles.label} title="EX: Normal, Bold, Extra Bold">Font Weight</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSfontWeight}
                            name="fontWeight"
                            onChange={(e) => handleStyleChange('fontWeight', e.target.value)}
                            className={styles.formInput}
                        />
                        <label htmlFor="textTransform" className={styles.label} title="EX: none, capitalize, lowercase, uppercase">Text Transform</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSStextTransform}
                            name="textTransform"
                            onChange={(e) => handleStyleChange('textTransform', e.target.value)}
                            className={styles.formInput}
                        />
                        <label htmlFor="display" className={styles.label} title="EX: none, block, inline, flex, grid">Display</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSdisplay}
                            name="display"
                            onChange={(e) => handleStyleChange('display', e.target.value)}
                            className={styles.formInput}
                        />
                        <label htmlFor="lineHeight" className={styles.label} title="Unitless Number (N.N), Length Units (Npx), or Percentages (NN%)">Line Height</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSlineHeight}
                            name="lineHeight"
                            onChange={(e) => handleStyleChange('lineHeight', e.target.value)}
                            className={styles.formInput}
                        />
                        <label htmlFor="border" className={styles.label} title="EX: dotted, dashed, solid, none, hidden">Border</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSborder}
                            name="border"
                            onChange={(e) => handleStyleChange('border', e.target.value)}
                            className={styles.formInput}
                        />
                        <label htmlFor="width" className={styles.label} title="Absolute lengths(NNpx), Relative lengths(NNem, NNrem, NN%, and Nvw/vh), or Keywords (auto)">Width</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSwidth}
                            name="width"
                            onChange={(e) => handleStyleChange('width', e.target.value)}
                            className={styles.formInput}
                        />
                        <label htmlFor="height" className={styles.label} title="Absolute lengths(NNpx), Relative lengths(NNem, NNrem, NN%, and Nvw/vh), or Keywords (auto)">Height</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSheight}
                            name="height"
                            onChange={(e) => handleStyleChange('height', e.target.value)}
                            className={styles.formInput}
                        />
                        <label htmlFor="position" className={styles.label} title="EX: static, relative, absolute, fixed, and sticky">Position</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSposition}
                            name="position"
                            onChange={(e) => handleStyleChange('position', e.target.value)}
                            className={styles.formInput}
                        />
                        <label htmlFor="top" className={styles.label} title="Used with Position: Absolute lengths(NNpx) or Relative lengths(NNem, NNrem, NN%, and Nvw/vh)">Top</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSStop}
                            name="top"
                            onChange={(e) => handleStyleChange('top', e.target.value)}
                            className={styles.formInput}
                        />
                        <label htmlFor="left" className={styles.label} title="Used with Position: Absolute lengths(NNpx) or Relative lengths(NNem, NNrem, NN%, and Nvw/vh)">Left</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSleft}
                            name="left"
                            onChange={(e) => handleStyleChange('left', e.target.value)}
                            className={styles.formInput}
                        />
                        <label htmlFor="right" className={styles.label} title="Used with Position: Absolute lengths(NNpx) or Relative lengths(NNem, NNrem, NN%, and Nvw/vh)">Right</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSright}
                            name="right"
                            onChange={(e) => handleStyleChange('right', e.target.value)}
                            className={styles.formInput}
                        />
                        <label htmlFor="bottom" className={styles.label} title="Used with Position: Absolute lengths(NNpx) or Relative lengths(NNem, NNrem, NN%, and Nvw/vh)">Bottom</label>
                        <input
                            type="text"
                            autoComplete="off"
                            value={CSSbottom}
                            name="bottom"
                            onChange={(e) => handleStyleChange('bottom', e.target.value)}
                            className={styles.formInput}
                        />
                    </form>
            :
                <></>
        }
        </>
    );
}

export default BadgeProperty;